import SelectStateProvince from "@/components/Select/SelectStateProvince";
import { useStateProvinces } from "@/components/Select/useStateProvinces";
import { SupportedCountry } from "@/constants/country";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

type Props = CFormItemProps & {
  value?: string | null;
  countryCode?: SupportedCountry | null;
  onChange?: (value?: string | null) => void;
  /** 空の場合の表示テキスト */
  placeholder?: string;
  inputWidth?: number;
  allowEmpty?: boolean;
};

/**
 * Card-based Form / StateProvinceItem
 * 州情報を表示するフォームアイテム
 */
export const CFormStateProvinceItem = buildCFormItem((props: Props) => {
  const {
    value,
    countryCode,
    placeholder = "-",
    onChange,
    readonly,
    inputWidth,
    allowEmpty = false,
    ...restProps
  } = props;

  const { stateProvinces = [], isLoading } = useStateProvinces(
    countryCode ?? undefined,
  );

  const selectedStateProvince = stateProvinces.find((c) => c.value === value);

  return (
    <CFormItemBase
      {...restProps}
      readComponent={selectedStateProvince?.label ?? placeholder}
      writeComponent={
        <SelectStateProvince
          width={inputWidth}
          country={countryCode ?? undefined}
          value={value ?? undefined}
          onValueChange={(value: string) => {
            onChange?.(value);
          }}
          onClear={allowEmpty ? () => onChange?.(null) : undefined}
        />
      }
      readonly={readonly || isLoading}
    />
  );
});
